import DistanceUnit from "./DistanceUnit";

const MILES_TO_NAUTICAL = 0.868976242;
const MILES_TO_KM = 1.609344;

const DistanceUtil = {
	addSpeedUnitsString: (num, units) => {
		if (units === DistanceUnit.NAUTICAL_MILES) {
			return num + " knots/nmph";
		}
		else if (units === DistanceUnit.KILOMETERS) {
			return num + " kmph";
		}
		else if (units === DistanceUnit.MILES) {
			return num + " mph";
		}
		return num;
	},
	distanceSquared: (x1, y1, x2, y2) => {
		const diffx = x1 - x2;
		const diffy = y1 - y2;
		return (diffx * diffx) + (diffy * diffy);
	},
	convert: (val, fromUnit, toUnit) => {
		if (fromUnit === DistanceUnit.MILES && toUnit === DistanceUnit.NAUTICAL_MILES) {
			return val * MILES_TO_NAUTICAL;
		}
		else if (fromUnit === DistanceUnit.NAUTICAL_MILES && toUnit === DistanceUnit.MILES) {
			return val / MILES_TO_NAUTICAL;
		}
		else if (fromUnit === DistanceUnit.MILES && toUnit === DistanceUnit.KILOMETERS) {
			return val * MILES_TO_KM;
		}
		else if (fromUnit === DistanceUnit.KILOMETERS && toUnit === DistanceUnit.MILES) {
			return val / MILES_TO_KM;
		}
		// TODO: fill this in.
		return val;
	}
};
export default DistanceUtil;
